import {
  LegacyResizableDrawer,
  LegacyResizableDrawerProps,
} from "./LegacyResizableDrawer";
import {
  Body,
  Content,
  ResizableDrawer as Drawer,
  ResizableDrawerProps as DrawerProps,
  Footer,
  Header,
} from "./ResizableDrawer";

type ResizableDrawerProps = DrawerProps | LegacyResizableDrawerProps;

function ResizableDrawer(props: ResizableDrawerProps) {
  if ("header" in props) {
    return <LegacyResizableDrawer {...props} />;
  }

  return <Drawer {...props} />;
}

ResizableDrawer.Content = Content;
ResizableDrawer.Header = Header;
ResizableDrawer.Body = Body;
ResizableDrawer.Footer = Footer;

export { ResizableDrawer };
